import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'
import { Extractor } from '@/api/utils'

export default {
  get: ({ reference, ...payload } = {}, options = {}) => {
    const { transform = Extractor } = options

    return graphql
      .request(Queries[`${reference.onModel}LastActivity`], { id: reference.ref, ...payload })
      .then(transform)
  },
}
